// frontend/src/components/sidebar/UserProfile.jsx
import React from 'react'
import { motion } from 'framer-motion'
import { User, Crown, Sparkles } from 'lucide-react'

const UserProfile = ({ user }) => {
  if (!user) return null

  return (
    <motion.div 
      whileHover={{ scale: 1.02 }}
      className="flex items-center space-x-3 p-3 bg-gradient-to-r from-slate-800/60 to-slate-700/60 backdrop-blur-xl rounded-2xl border border-slate-600/30 relative overflow-hidden"
    >
      {/* Animated background effect */}
      <motion.div
        animate={{ 
          scale: [1, 1.2, 1],
          opacity: [0.1, 0.2, 0.1]
        }}
        transition={{ duration: 3, repeat: Infinity }}
        className="absolute inset-0 bg-gradient-to-r from-blue-500/20 to-purple-500/20 rounded-2xl"
      />
      
      {/* Avatar */}
      <div className="relative flex-shrink-0">
        <motion.div 
          whileHover={{ scale: 1.1, rotate: 5 }}
          className="w-12 h-12 bg-gradient-to-br from-blue-500 via-purple-600 to-indigo-600 rounded-2xl flex items-center justify-center shadow-lg relative"
        >
          <User className="h-6 w-6 text-white" />
          
          {/* Sparkle effect */}
          <motion.div
            animate={{ 
              scale: [0, 1, 0],
              rotate: [0, 180, 360]
            }}
            transition={{ 
              duration: 2, 
              repeat: Infinity,
              repeatDelay: 3
            }}
            className="absolute -top-1 -right-1"
          >
            <Sparkles className="h-3 w-3 text-yellow-300" />
          </motion.div>
        </motion.div>
        
        {/* Online status indicator */}
        <motion.div
          animate={{ scale: [1, 1.2, 1] }}
          transition={{ duration: 2, repeat: Infinity }}
          className="absolute -bottom-1 -right-1 w-4 h-4 bg-green-500 border-2 border-slate-800 rounded-full shadow-lg"
        />
      </div>
      
      {/* User info */}
      <div className="flex-1 min-w-0 relative z-10">
        <div className="flex items-center space-x-2 mb-1">
          <motion.p 
            className="text-sm font-bold text-white truncate"
            animate={{ opacity: [0.8, 1, 0.8] }}
            transition={{ duration: 3, repeat: Infinity }}
          >
            {user.full_name || user.username}
          </motion.p>
          
          {/* Premium badge */}
          <motion.div
            whileHover={{ scale: 1.1 }}
            className="flex-shrink-0"
          >
            <Crown className="h-3 w-3 text-yellow-400" />
          </motion.div>
        </div>
        
        <p className="text-xs text-slate-300 truncate font-medium">
          {user.email}
        </p>
        
        {/* Activity indicator */}
        <div className="flex items-center space-x-2 mt-2">
          <motion.div
            animate={{ opacity: [0.5, 1, 0.5] }}
            transition={{ duration: 1.5, repeat: Infinity }}
            className="w-1.5 h-1.5 bg-green-400 rounded-full"
          />
          <span className="text-xs text-green-400 font-semibold">Active</span>
        </div>
      </div>
    </motion.div>
  )
}

export default UserProfile